import { BASE_URL } from './index'

export async function getTokens(cb, data, err) {
  fetch(`${BASE_URL}api/token/`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(async (res) => {
      if (!res.ok) throw await res.json()
      return res.json();
    })
    .then((json) => {
      cb(json["access"], json['refresh'])
    }).catch((e) => {
      err(e)
    })
}

export async function verifyToken(valid, token, err) {
  fetch(`${BASE_URL}auth/jwt/verify/`, {
    method: 'POST',
    body: JSON.stringify({token}),
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(async (res) => {
      if (!res.ok) return err(res.status)
      valid()
    })
}

export async function refreshToken(cb, token, err) {
  fetch(`${BASE_URL}api/token/refresh/`, {
    method: 'POST',
    body: JSON.stringify({ refresh: token }),
    headers: {
      'Content-Type': 'application/json',
    }
  }).catch((e) => {
    err(e)
  })
    .then((res) => {
      console.log(res)
      if (!res.ok) return err(res.status)
      return res.json();
    })
    .then((json) => {
      cb(json["access"])
    });
}
